
// Import article collections
import { ArticleData } from './types';
import { mlFundamentalsArticles } from './ml-fundamentals';
import { systemDesignArticles } from './system-design';
import { additionalArticles } from './additional-articles';
import { userBehaviourSequence } from './user-behaviour-sequence';
import { evolutionCandidateGeneration } from './evolution';

// Combine all articles into a single array
export const articles: ArticleData[] = [
  ...mlFundamentalsArticles,
  ...systemDesignArticles,
  ...additionalArticles,
  userBehaviourSequence,
  evolutionCandidateGeneration, // Add the proper evolution article
];

// Export article query functions
export { getArticleBySlug, getArticleBySlugSync } from '@/utils/articleQueries';

// Re-export types for convenience
export * from './types';
